module.exports = __webpack_public_path__ + "img/derbasov.b47c6760.png";